import * as React from 'react';
import {Grid, TextField} from '@mui/material';

import { SearchField } from 'views/Dashboard/shared';
import { searchObjects } from 'utils/searchObjects';

const etype = [
    {
      value: 'All',
      label: 'All'
    },
    {
        value: 'Home',
        label: 'Home Page'
    },
    {
        value: 'Contact',
        label: 'Contact Page'
    },
    {
      value: 'Stock',
      label: 'Stock Page'
    },

  ];

const SubscriptionsFilters = (props) => {

    const {
        items,
        onChange,
        
    } = props;

    const [search, setSearch] = React.useState("");
    const [enquireType, setEnquireType] = React.useState('All');
  
    React.useEffect(() => {
        console.log("RENDERING FILTERS");
        onFilterItems();
    },[items, search, enquireType]);

  
    const handleSearch = (value) => setSearch(value);
    const handleEnquireType = (value) => setEnquireType(value);
    const filterSearch = (list) => searchObjects(list, search);
    const filterEnquireType = (list) => {
        console.log("TYPE : ", enquireType);
        switch (enquireType) {

            case 'All':
        
                return list;

            case 'Home':

                return list.filter(item => item.type == 'Home');
            case 'Stock':

                return list.filter(item => item.type == 'Stock');

            case 'Contact':

                return list.filter(item => item.type == 'Contact');

            default:
                return list;
        }
    }
   
    const onFilterItems = () => {
        
        let filteredItems = items;

        filteredItems = filterSearch(filteredItems);
        filteredItems = filterEnquireType(filteredItems);
        console.log(filteredItems);
        onChange(filteredItems);

    }

    return (
        <Grid
        container
        spacing={3}
        >
            <Grid
            item
            md={3}
            xs={12}
            >
                <SearchField onChange={handleSearch} />
            </Grid>
             <Grid
                item
                md={3}
                xs={12}
            >
                <TextField
                  fullWidth
                  label="Enquire Type"
                  name="enquireType"
                  onChange={(event) => handleEnquireType(event.target.value)}
                  required
                  select
                  SelectProps={{ native: true }}
                  value={enquireType}
                  variant="outlined"
                >
                  {etype.map((option) => (
                    <option
                      key={option.value}
                      value={option.value}
                    >
                      {option.label}
                    </option>
                  ))}
                </TextField>
            </Grid>        
        </Grid>

    )

}

export default SubscriptionsFilters;